<button (click)="_excel.generateReport()" class="button-30" role="button">
  <ng-content></ng-content>
</button>
